import React from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationTriangle, faInfoCircle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { useExcluirLote } from '../../../../hooks/useSngpc';
import { EstoqueInventarioType } from '../../../../data/sngpc';
import LinkProduto from '../../../../components/common/LinkProduto';

interface ModalExcluirProdutoProps {
    show: boolean;
    onHide: () => void;
    produto: EstoqueInventarioType | null;
    inventarioId?: number;
}

const ModalExcluirProduto: React.FC<ModalExcluirProdutoProps> = ({ show, onHide, produto, inventarioId }) => {
    const excluirLoteMutation = useExcluirLote();

    const handleConfirmar = async () => {
        if (!produto?.loteId) return;

        try {
            await excluirLoteMutation.mutateAsync({
                loteId: produto.loteId
            });
            onHide();
        } catch (error) {
            console.error('Erro ao excluir produto:', error);
        }
    };

    if (!produto) return null;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FontAwesomeIcon icon={faTimes} className="me-2 text-danger-emphasis" />
                    Excluir Produto do Inventário
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center py-3">
                    <FontAwesomeIcon icon={faExclamationTriangle} size="3x" className="text-danger-emphasis mb-3" />
                    <h5 className="mb-3">Confirmar Exclusão</h5>
                    <p className="text-body-tertiary mb-4">
                        Tem certeza de que deseja excluir este produto do inventário?
                    </p>

                    <div className="border rounded p-3 mb-4 text-start">
                        <LinkProduto produtoId={produto.produtoId}>
                            <strong>{produto.nomeProduto || 'Produto sem descrição'}</strong>
                        </LinkProduto>
                        <div className="small text-body-secondary">
                            Código: {produto.produtoCodigo || produto.produtoId}
                        </div>
                        <div className="small text-body-secondary">
                            Lote: <span className="badge bg-secondary">{produto.numero || produto.lote || 'Sem lote'}</span>
                        </div>
                        <div className="small text-body-secondary">
                            RMS: <code>{produto.rms || '-'}</code>
                        </div>
                        <div className="small text-body-secondary">
                            Quantidade: {produto.quantidade}
                        </div>
                    </div>

                    <Alert variant="warning" className="border border-warning border-opacity-25 bg-warning-subtle text-start">
                        <div className="text-warning-emphasis">
                            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                            <strong>Ação irreversível:</strong>
                            <ul className="mb-0 mt-2">
                                <li>O produto será removido permanentemente do inventário</li>
                                <li>Esta ação não pode ser desfeita</li>
                                <li>Você precisará incluir o produto novamente se necessário</li>
                            </ul>
                        </div>
                    </Alert>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button
                    variant="danger"
                    onClick={handleConfirmar}
                    disabled={excluirLoteMutation.isPending}
                >
                    <FontAwesomeIcon icon={faTimes} className="me-2" />
                    {excluirLoteMutation.isPending ? 'Excluindo...' : 'Confirmar Exclusão'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalExcluirProduto; 